export default {
  metadata: {
    version: '2.0.0',
    id: 'avatar-information-2.0.0',
    name: 'JDSAvatarV2Information'
  },
  hierarchy: {
    container: [
      'jds_avatar_v2_default',
      {
        'badge-container': ['jds_badge_v2']
      }
    ]
  },
  base: {
    container: {
      'flex-direction': '{flexDirection.stack}',
      'justify-content': '{justifyContent.start}',
      'align-items': '{alignItems.start}',
      opacity: '{opacity.enabled}',
      hidden: false
    },
    'badge-container': {
      'padding-left': '{custom_11}',
      'padding-top': '{custom_11}',
      'z-index': 1,
      disabled: true
    },
    jds_avatar_v2_default: {
      size: 'medium'
    },
    jds_badge_v2: {
      size: 'small',
      kind: 'information',
      informationKind: 'icon-circle',
      border: true
    }
  },
  variant: {
    kind: {
      label: {
        jds_badge_v2: {
          informationKind: 'label'
        }
      }
    },
    size: {
      'xtra-small': {
        container: {
          hidden: true
        }
      }
    },
    disabled: {
      true: {
        container: {
          disabled: true,
          opacity: '{opacity.disabled}'
        }
      }
    }
  },
  combination: [
    {
      small: {
        icon: {
          'bottom-right': {
            'badge-container': {
              'padding-left': '{custom_15}',
              'padding-top': '{custom_15}'
            },
            jds_avatar_v2_default: {
              size: 'small'
            },
            jds_badge_v2: {
              size: 'small'
            }
          },
          'bottom-center': {
            container: {
              'justify-content': '{justifyContent.center}',
              'align-items': '{alignItems.center}'
            },
            'badge-container': {
              'align-self': 'flex-end',
              'padding-left': '{custom_5}',
              'padding-top': '{l}'
            },
            jds_avatar_v2_default: {
              size: 'small'
            },
            jds_badge_v2: {
              size: 'small'
            }
          }
        },
        label: {
          'bottom-right': {
            container: {
              hidden: true
            }
          },
          'bottom-center': {
            container: {
              hidden: true
            }
          }
        }
      },
      medium: {
        icon: {
          'bottom-center': {
            container: {
              'justify-content': '{justifyContent.center}',
              'align-items': '{alignItems.center}'
            },
            'badge-container': {
              'align-self': 'flex-end',
              'padding-left': '{custom_5}',
              'padding-top': '{custom_10}'
            },
            jds_avatar_v2_default: {
              size: 'medium'
            },
            jds_badge_v2: {
              size: 'small'
            }
          }
        },
        label: {
          'bottom-right': {
            'badge-container': {
              'padding-left': '{custom_11}',
              'padding-top': '{l}'
            },
            jds_avatar_v2_default: {
              size: 'medium'
            },
            jds_badge_v2: {
              size: 'xtra-small'
            }
          },
          'bottom-center': {
            container: {
              'justify-content': '{justifyContent.center}',
              'align-items': '{alignItems.center}'
            },
            'badge-container': {
              'align-self': 'flex-end',
              'padding-left': '{custom_5}',
              'padding-top': '{custom_10}'
            },
            jds_avatar_v2_default: {
              size: 'medium'
            },
            jds_badge_v2: {
              size: 'xtra-small'
            }
          }
        }
      },
      large: {
        icon: {
          'bottom-right': {
            'badge-container': {
              'padding-left': '{l}',
              'padding-top': '{l}'
            },
            jds_avatar_v2_default: {
              size: 'large'
            },
            jds_badge_v2: {
              size: 'medium'
            }
          },
          'bottom-center': {
            container: {
              'justify-content': '{justifyContent.center}',
              'align-items': '{alignItems.center}'
            },
            'badge-container': {
              'align-self': 'flex-end',
              'padding-left': '{custom_5}',
              'padding-top': '{xxl}'
            },
            jds_avatar_v2_default: {
              size: 'large'
            },
            jds_badge_v2: {
              size: 'medium'
            }
          }
        },
        label: {
          'bottom-right': {
            'badge-container': {
              'padding-left': '{l}',
              'padding-top': '{custom_10}'
            },
            jds_avatar_v2_default: {
              size: 'large'
            },
            jds_badge_v2: {
              size: 'xtra-small'
            }
          },
          'bottom-center': {
            container: {
              'justify-content': '{justifyContent.center}',
              'align-items': '{alignItems.center}'
            },
            'badge-container': {
              'align-self': 'flex-end',
              'padding-left': '{custom_5}',
              'padding-top': '{xxl}'
            },
            jds_avatar_v2_default: {
              size: 'large'
            },
            jds_badge_v2: {
              size: 'xtra-small'
            }
          }
        }
      },
      'xtra-large': {
        icon: {
          'bottom-right': {
            'badge-container': {
              'padding-left': '{xl}',
              'padding-top': '{xl}'
            },
            jds_avatar_v2_default: {
              size: 'xtra-large'
            },
            jds_badge_v2: {
              size: 'large'
            }
          },
          'bottom-center': {
            container: {
              'justify-content': '{justifyContent.center}',
              'align-items': '{alignItems.center}'
            },
            'badge-container': {
              'align-self': 'flex-end',
              'padding-left': '{custom_5}',
              'padding-top': '{custom_19}'
            },
            jds_avatar_v2_default: {
              size: 'xtra-large'
            },
            jds_badge_v2: {
              size: 'large'
            }
          }
        },
        label: {
          'bottom-right': {
            'badge-container': {
              'padding-left': '{custom_8}',
              'padding-top': '{xl}'
            },
            jds_avatar_v2_default: {
              size: 'xtra-large'
            },
            jds_badge_v2: {
              size: 'xtra-small'
            }
          },
          'bottom-center': {
            container: {
              'justify-content': '{justifyContent.center}',
              'align-items': '{alignItems.center}'
            },
            'badge-container': {
              'align-self': 'flex-end',
              'padding-left': '{custom_5}',
              'padding-top': '{custom_19}'
            },
            jds_avatar_v2_default: {
              size: 'xtra-large'
            },
            jds_badge_v2: {
              size: 'xtra-small'
            }
          }
        }
      },
      'xtra-xtra-large': {
        icon: {
          'bottom-right': {
            'badge-container': {
              'padding-left': '{custom_7}',
              'padding-top': '{custom_7}'
            },
            jds_avatar_v2_default: {
              size: 'xtra-xtra-large'
            },
            jds_badge_v2: {
              size: 'xtra-xtra-large'
            }
          },
          'bottom-center': {
            container: {
              'justify-content': '{justifyContent.center}',
              'align-items': '{alignItems.center}'
            },
            'badge-container': {
              'align-self': 'flex-end',
              'padding-left': '{custom_5}',
              'padding-top': '{custom_21}'
            },
            jds_avatar_v2_default: {
              size: 'xtra-xtra-large'
            },
            jds_badge_v2: {
              size: 'xtra-xtra-large'
            }
          }
        },
        label: {
          'bottom-right': {
            'badge-container': {
              'padding-left': '{custom_6}',
              'padding-top': '{custom_7}'
            },
            jds_avatar_v2_default: {
              size: 'xtra-xtra-large'
            },
            jds_badge_v2: {
              size: 'medium'
            }
          },
          'bottom-center': {
            container: {
              'justify-content': '{justifyContent.center}',
              'align-items': '{alignItems.center}'
            },
            'badge-container': {
              'align-self': 'flex-end',
              'padding-left': '{custom_5}',
              'padding-top': '{custom_22}'
            },
            jds_avatar_v2_default: {
              size: 'xtra-xtra-large'
            },
            jds_badge_v2: {
              size: 'medium'
            }
          }
        }
      }
    }
  ],
  combination_config: [['size', 'kind', 'placement']],
  api: {
    data: {
      jds_avatar_v2_default: {
        image: {
          type: 'image',
          name: 'avatarImage'
        },
        kind: {
          type: 'JDSAvatarV2Default.kind',
          name: 'avatarKind'
        },
        initials: {
          type: 'string',
          name: 'avatarInitials'
        }
      },
      jds_badge_v2: {
        icon: {
          type: 'icon',
          name: 'badgeIcon'
        },
        label: {
          type: 'string',
          name: 'label'
        },
        border: {
          type: 'boolean',
          name: 'badgeBorder'
        },
        color: {
          type: 'JDSBadgeV2Information.color',
          name: 'badgeColor'
        },
        appearance: {
          type: 'JDSBadgeV2Information.appearance',
          name: 'badgeAppearance'
        }
      }
    },
    config: {
      kind: {
        values: ['icon', 'label']
      },
      placement: {
        values: ['bottom-right', 'bottom-center']
      },
      size: {
        values: [
          'medium',
          'xtra-xtra-large',
          'xtra-large',
          'large',
          'small',
          'xtra-small'
        ]
      },
      disabled: {
        values: [false, true]
      }
    },
    a11y: {
      container: {
        properties: {
          'aria-label': {
            name: 'ariaLabel',
            value: 'Avatar with Information Badge'
          },
          'aria-describedby': {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          }
        }
      }
    }
  }
};
